import React, { useRef } from "react";
import {
  AspectRatio,
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { FiPlayCircle } from "react-icons/fi";

const OMIDEX_TRAINING_VIDEO_URL =
  process.env.REACT_APP_OMIDEX_TRAINING_VIDEO_URL ||
  "/videos/omidex-training.mp4";

type OmidexTrainingButtonProps = {
  size?: "xs" | "sm" | "md" | "lg";
  variant?: "solid" | "outline" | "ghost" | "link";
  width?: string | number;
};

export const OmidexTrainingButton = ({
  size = "md",
  variant = "outline",
  width,
}: OmidexTrainingButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const modalBg = useColorModeValue("white", "dark.50");

  const handleClose = () => {
    videoRef.current?.pause();
    onClose();
  };

  return (
    <>
      <Button
        size={size}
        variant={variant}
        width={width}
        borderRadius="xl"
        rightIcon={<Icon as={FiPlayCircle as any} />}
        onClick={onOpen}
      >
        آموزش سرمایه گذاری
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        isCentered
        size="4xl"
        scrollBehavior="inside"
      >
        <ModalOverlay backdropFilter="blur(5px)" />
        <ModalContent bg={modalBg} borderRadius="2xl" mx={4} overflow="hidden">
          <ModalHeader>آموزش سرمایه گذاری</ModalHeader>
          <ModalCloseButton />
          <ModalBody p={{ base: 2, md: 4 }}>
            <AspectRatio
              ratio={16 / 9}
              w="100%"
              bg="black"
              borderRadius="xl"
              overflow="hidden"
            >
              <video
                ref={videoRef}
                src={OMIDEX_TRAINING_VIDEO_URL}
                controls
                preload="metadata"
                playsInline
                style={{ width: "100%", height: "100%", display: "block" }}
              />
            </AspectRatio>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
